import MqttClient from '../../../notification/Client/MqttClient'
import ApiClient from '../../../utils/ApiClient'
import Config from '../../../config'
import { has as hasFeature } from '../../../utils/features'
import RaceUpdate from './raceUpdate'

export default function() {
    const apiClient = new ApiClient();
    const mqttClient = new MqttClient();
    const raceUpdateMiddleware = new RaceUpdate(Config, apiClient, mqttClient, hasFeature)
    //map & wrap exported middleware funcs 
    return Object.keys(raceUpdateMiddleware).map(key => store => next => action => raceUpdateMiddleware[key](store, next, action))
}



// WEBPACK FOOTER //
// ./modules/HorseRacing/middleware/raceUpdateFactory.js